module.exports = __webpack_public_path__ + "static/media/loader.4738d542.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/loader.svg
// module id = 3229
// module chunks = 1